import Highcharts from 'highcharts';
import React from 'react';
import HighchartsReact from 'highcharts-react-official';

type PotentialSalesValueProps = {
  series: Highcharts.SeriesLineOptions[];
};

const PotentialSalesValue: React.FC<PotentialSalesValueProps> = ({ series }) => {
  const options: Highcharts.Options = {
    chart: { style: { fontFamily: 'DM Sans, Arial', fontSize: '13px' } },
    credits: { enabled: false },
    title: { text: '' },
    xAxis: { title: { text: 'Production Week' } },
    yAxis: { title: { text: 'NOK' } },
    tooltip: {
      shared: true,
      useHTML: true,
      style: { fontSize: '12px' },
      formatter() {
        const header = `<span style="font-size:13px;font-weight:600">Week ${this.x}</span><br/>`;
        const rows = (this.points ?? [])
          .map((pt) => {
            const value = Highcharts.numberFormat(pt.y ?? 0, 2, '.', ',');
            return `<span style="color:${pt.color}">${pt.series.name}: <b>${value} NOK</b></span>`;
          })
          .join('<br/>');
        return header + rows;
      },
    },
    series,
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default React.memo(PotentialSalesValue);
